import React, { FunctionComponent, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';
import { ButtonLink } from 'components/Buttons/ButtonLink';
import { RootState } from 'rootReducer';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { useNativeEvents } from 'hooks/useNativeEvents';
import { IconButton } from 'components/Buttons/IconButton';
import { showAuthenticationEmailPromptForm } from 'features/current-user/currentUserSlice';

export const ChatLoginPrompt: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { isNativeAppWebview } = useContext(UserAgentContext);
  const channel = useSelector(
    (state: RootState) => state.channel.channelDetails
  );
  const { nativeUrlSchemeLink } = useNativeEvents();

  if (isNativeAppWebview) {
    return (
      <div className={styles['chat__prompt']}>
        <IconButton
          label={'Login to join the crowd'}
          href={nativeUrlSchemeLink('mixlr', 'auth', {
            url: `${import.meta.env.VITE_WEBSITE_ENDPOINT}/signin`
          })}
          external={true}
          icon={'crowd'}
          showLabel={true}
          noBackground={true}
        />
      </div>
    );
  }

  return (
    <div className={styles['chat__prompt']}>
      <ButtonLink
        label={'Join the crowd'}
        onClick={() =>
          dispatch(
            showAuthenticationEmailPromptForm(
              `To chat with ${channel && channel.username}'s crowd`
            )
          )
        }
        icon={'crowd'}
        iconSize={16}
      />
    </div>
  );
};
